import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import API from "../api/deliveryApi"; 

let app = null;
let messaging = null;
let vapidKey = null;
let initPromise = null; 

export const initFirebase = async () => {
    // ✅ Include config in the early return
    if (app) return { messaging, vapidKey, config: app.options };
    
    // Return the ongoing promise if currently fetching
    if (initPromise) return initPromise; 

    initPromise = (async () => {
        try {
            const { data } = await API.get("/config/firebase");

            app = initializeApp({
                apiKey: data.apiKey,
                authDomain: data.authDomain,
                projectId: data.projectId,
                storageBucket: data.storageBucket,
                messagingSenderId: data.messagingSenderId,
                appId: data.appId,
                measurementId: data.measurementId
            });

            messaging = getMessaging(app);
            vapidKey = data.vapidKey;

            // ✅ Return the raw data object so we can pass it to the SW
            return { messaging, vapidKey, config: data };
        } catch (error) {
            console.error("Failed to initialize Firebase:", error);
            throw error;
        }
    })();

    return initPromise;
};